import { useCallback, useEffect, useState } from 'react'

import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { subscibeTo, useDataBoxSelector } from 'app/common/data-box-store'
import { OrderByClassesDetailsGroup } from 'app/dataTypes/reports/data/common/ordersByClasses'
import { detailsFilter } from 'app/common/ui-next/_filter-compilations/details'

import {
  buildingsFilter,
  buildingsFilterSelection,
  orderByClassesGroupFilterSelection,
  orgsFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = {
  id: string
  pending: boolean
}

export const BuildingsFilter = ({ id, pending }: Props) => {
  const [filterVisibility, setFilterVisibility] = useState(false)

  const buildings = useDataBoxSelector(buildingsFilter, () => buildingsFilter.data)

  const handleOrgsFilter = useCallback((data: Array<string>) => {
    if (
      data.length === 1 &&
      detailsFilter.data &&
      orderByClassesGroupFilterSelection.data ===
        OrderByClassesDetailsGroup.ByComplexesAndAllowances
    ) {
      setFilterVisibility(true)
      return
    }
    setFilterVisibility(false)
  }, [])

  const handleDetailsGroupFilter = useCallback((data: OrderByClassesDetailsGroup) => {
    if (
      data === OrderByClassesDetailsGroup.ByComplexesAndAllowances &&
      orgsFilterSelection.data.length === 1 &&
      detailsFilter.data
    ) {
      setFilterVisibility(true)
      return
    }
    setFilterVisibility(false)
  }, [])

  const handleDetailsFilter = useCallback((data: boolean) => {
    if (
      data &&
      orgsFilterSelection.data.length === 1 &&
      orderByClassesGroupFilterSelection.data ===
        OrderByClassesDetailsGroup.ByComplexesAndAllowances
    ) {
      setFilterVisibility(true)
      return
    }
    setFilterVisibility(false)
  }, [])

  useEffect(() => {
    const unsubscribeOrgs = subscibeTo<Array<string>>(orgsFilterSelection.id, handleOrgsFilter)

    const unsubsribeDetailsGroup = subscibeTo<OrderByClassesDetailsGroup>(
      orderByClassesGroupFilterSelection.id,
      handleDetailsGroupFilter,
    )
    const unsubscribeDetails = subscibeTo<boolean>(detailsFilter.id, handleDetailsFilter)

    return () => {
      unsubscribeOrgs()
      unsubsribeDetailsGroup()
      unsubscribeDetails()
    }
  }, [handleDetailsGroupFilter, handleDetailsFilter, handleOrgsFilter])

  return (
    filterVisibility && (
      <PlainItemsSelectorBox
        id={id}
        label="Корпус"
        header="Выбор корпуса"
        dataBoxData={buildingsFilter}
        dataBoxSelection={buildingsFilterSelection}
        pleaseSelectText="Нет данных"
        disabled={pending}
        hidden={buildings.length < 2}
      />
    )
  )
}
